import { Helmet } from 'react-helmet';
import { CSVLink } from 'react-csv';
import Header from '../Header/Header';
import FinderTable from '../FinderTable/FinderTable';
import useAPIData from '../../hooks/useAPIData';
import useCustomReport from '../../hooks/useCustomReport';
import useMsalContactData from '../../hooks/useMsalContactData';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Dropdown from '../Dropdown/Dropdown';
import config from '../../config';

export default function Finder() {
  const contactRole = useMsalContactData('role');
  const systemsMetadata = useAPIData('/nld_tracker/finder/systems_metadata');
  const [reportName, reportData, reportLink, handleCustomReport] =
    useCustomReport();

  if (systemsMetadata && contactRole) {
    return (
      <div className='app'>
        <Helmet>
          <title>Home · NLD Refinement</title>
        </Helmet>
        <Header />
        <div className='body'>
          <FinderTable systemsMetadata={systemsMetadata} />
          {config.customReports.canAccess.includes(contactRole) ? (
            <div className='custom-reports'>
              <Dropdown
                dropdownOptions={config.customReports.dropdownOptions}
                handleSelectedChange={handleCustomReport}
                selectMessage='Generate Custom Report'
                selectClassName='table-dropdown'
                handleArgs={[]}
              />
              <CSVLink
                data={reportData}
                filename={`${reportName}_${config.getCurrentDateTime()}.csv`}
                ref={reportLink}
                target='_blank'
              />
            </div>
          ) : null}
          <div>
            <br></br>
            <br></br>
            <strong>Usage Tips:</strong>
            <ul>
              <li>
                To sort the table by a particular column, click on the column's
                title
                <ul>
                  <li>Click once for ascending order</li>
                  <li>Click twice for descending order</li>
                  <li>Click three times to stop sorting</li>
                </ul>
              </li>
              <li>
                For multi-column sorting, click the first column's title, hold
                "Shift", and then click the next column's title
              </li>
              <li>
                Use the dropdown below the table to select the number of systems
                to display
              </li>
              <li>Click 'Export to CSV' to export the filtered data</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
  return <LoadingSpinner />;
}
